import { createQueryKeys } from '@/lib/query-factory';
import { queryOptions } from '@tanstack/react-query';
import * as api from './works.api';

const keys = createQueryKeys('works');

export const workQueries = {
  keys,

  list: (projectId?: number) =>
    queryOptions({
      queryKey: keys.list({ projectId: projectId ?? 'all' }),
      queryFn: () => api.fetchWorks(projectId),
      enabled: projectId !== 0,
    }),

  detail: (id: number) =>
    queryOptions({
      queryKey: keys.detail(id),
      queryFn: () => api.fetchWork(id),
      enabled: !!id,
    }),
};

export const workMutations = {
  // Note: Add create, update, delete mutations when API endpoints are available
  // Following the pattern from the labels example in the plan
};
